import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';
import type { EditorInlineReactionsPubSubHandlerProps } from './EditorInlineReactionsPubSubHandler.ts';

export type { EditorInlineReactionsPubSubHandlerProps } from '../src/pubsub/EditorInlineReactionsPubSubHandler.tsx';

export const EditorInlineReactionsPubSubHandler: LoadableType<EditorInlineReactionsPubSubHandlerProps> =
	LoadableLazy({
		loader: async () =>
			(
				await import(
					/* webpackChunkName: "loadable-EditorInlineReactionsPubSubHandler" */ '../src/pubsub/EditorInlineReactionsPubSubHandler.tsx'
				)
			).EditorInlineReactionsPubSubHandler,
	});
